import * as React from 'react';

import { SurveyQuestionProps } from './SurveyQuestion';

export interface TypeProgressProps extends SurveyQuestionProps {}

/**
 * @name TypeProgress
 * @description Not yet defined, but this one will be a progress bar that
 * informs our user how far they are in the survey
 */
export const TypeProgress = (props: TypeProgressProps) => {
  const { question } = props;

  return (
    <>
      <h2
        className="mt-64 font-beatrice-semibold text-3xl leading-normal md:px-0 md:text-5xl md:leading-normal"
        dangerouslySetInnerHTML={{ __html: question.text }}
      />
    </>
  );
};
